<div class="content flex-fill">
	<div class="flex flex-column flex-fill min-width-zero gap-24">
		@if (categoryGroupNames.length > 1) {
			<div class="flex flex-column gap-16">
				<label>{{ 'mes.mes-production-terminal.category-select-label' | translate }}</label>
				<mat-select [(ngModel)]="currentCategoryGroupName">
					@for (categoryGroupName of categoryGroupNames; track categoryGroupName) {
						<mat-option [value]="categoryGroupName">{{ categoryGroupName }}</mat-option>
					}
				</mat-select>
			</div>
		}
		<div class="flex flex-column gap-16 min-height-zero flex-fill">
			<label>
				{{ 'mes.mes-production-terminal.choose-worktask.full-list-label' | translate }}
			</label>
			<ul class="tasks">
				@for (workTask of currentWorkTasks; track workTask) {
					<li (click)="onWorkTaskClicked(workTask)">({{ workTask.alias }}) {{ workTask.name }}</li>
				}
			</ul>
		</div>
	</div>
	<div class="flex flex-column gap-16 flex-fill">
		@if (filteredFavouriteWorkTasks?.length) {
			<label>
				{{ 'mes.mes-production-terminal.choose-worktask.fav-list-label' | translate }}
			</label>
		}
		<div class="fav">
			<div class="favorite-tasks">
				@for (workTask of filteredFavouriteWorkTasks; track workTask) {
					<div class="qr-tile" (click)="onWorkTaskClicked(workTask)">
						<qrcode [qrdata]="'ACS_W_' + workTask.alias" [width]="200" [title]="workTask.name" [errorCorrectionLevel]="'M'"></qrcode>
						<div class="title">{{ workTask.name }}</div>
					</div>
				}
			</div>
		</div>
	</div>
	@if (offTask) {
		<div class="off-task-container">
			<label><span class="material-icons">logout</span></label>
			<div class="qr-tile" (click)="onWorkTaskClicked(offTask)">
				<qrcode [qrdata]="'ACS_W_' + offTask.alias" [width]="200" [title]="offTask.name" [errorCorrectionLevel]="'M'"></qrcode>
				<div class="title">{{ offTask.name }}</div>
			</div>
		</div>
	}
</div>
